export default "/assets/images/chart-sm-06.527d9c4c14b188de.svg";